import { MutationTree } from 'vuex';
import { ExtrasState, Extra } from '@/store/extras/types';
import { Pager } from '../pager.types';

const mutations: MutationTree<ExtrasState> = {
  fetchedExtras: (state, payload: {
    pager: Pager,
    extras: Extra[]
  }) => {
    state.pager = payload.pager
    state.extras = payload.extras
  },
};

export default mutations;
